import { render, staticRenderFns } from "./ShopFilter.vue?vue&type=template&id=036ae128&scoped=true&"
import script from "./ShopFilter.vue?vue&type=script&lang=js&"
export * from "./ShopFilter.vue?vue&type=script&lang=js&"
import style0 from "./ShopFilter.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ShopFilter.vue?vue&type=style&index=1&id=036ae128&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036ae128",
  null
  
)

export default component.exports